// extracted by mini-css-extract-plugin
export default {"box":"style_box__1plo2","left":"style_left__cz9iv","right":"style_right__xzAkY","iconContainer":"style_iconContainer__Nwt61"};